import { Group, Text, Image } from "@mantine/core";
import logo from "../../media/iRdrive-logo.png";
import applogo from "../../media/iRdrive-logo.png";

import classes from "./Logo.module.css";


interface LogoProps {
  logo?: string;
  name?: string;
}
export default function Logo({logo = applogo, name = "iR DRIVE"}: LogoProps): React.JSX.Element {
  return (
    <Group className={classes.logo}>
      <Image radius="md" h={40} w={40} src={logo} alt={`${name} logo`} />
      <Text fs="italic" size="xl">
        {name}
      </Text>
    </Group>
  );
}
